<template>
  <v-dialog :value="show" persistent width="800">
    <v-card class="delete-dialog">
      <v-card-title class="main-subtitle fw-bold dark--text">{{ active ? 'Update' : 'Create New'}} Profile</v-card-title>
      <v-card-text class="pt-4">
        <v-form v-model="valid" ref="form">
          <p class="input-label text-style dark--text mb-0">Choose Profile Target</p>
          <v-row>
            <v-col md="6" sm="12">
              <v-select
                v-model="type"
                :items="types"
                item-text="text"
                item-value="value"
                :menu-props="{ offsetY: true }"
                class="select-field"
                hide-details
                :rules="[rules.required]"
              />
            </v-col>
            <v-col md="6" sm="12">
              <v-select
                v-model="secondType"
                :items="secondTypes"
                :menu-props="{ offsetY: true }"
                class="select-field"
                hide-details
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <database-config :db-config="dbConfig" @dbConfigUpdated="updateDbConfig" v-if="secondType === 'database'" ref="databaseConfig"/>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <p class="input-label text-style dark--text mb-0 mt-5">Profile Type</p>
              <v-select
                v-model="commandType"
                :items="scanCommandTypes"
                :menu-props="{ offsetY: true }"
                class="select-field"
                hide-details
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <my-network-documents
                :collector.sync="collector"
                :collectors="filteredCollectors"
                :loadingCollectors="loadingCollectors"
                :path.sync="path"
              />
            </v-col>
          </v-row>
          <v-row v-if="commandType === 'deep'" class="mb-5">
            <v-col cols="12">
              <div class="deep-scan-filters-header">
                <p class="input-label text-style dark--text m-0">Filters</p>
                <v-icon style="cursor-pointer" @click="hideDeepScanFilters = !hideDeepScanFilters">{{ hideDeepScanFilters ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
              </div>
              <div v-show="!hideDeepScanFilters" class="deep-scan-filters">
                <v-col cols="12">
                  <v-row align="center" class="mb-5">
                    <v-col class="px-0 py-0">
                    <v-checkbox
                        v-model="deepScanFilters.extensions.enabled"
                        hide-details
                        class="shrink mr-2 my-0"
                      >
                      <template v-slot:label>
                        <p class="input-label text-style dark--text my-0">Filter by Extensions</p>
                      </template>
                    </v-checkbox>
                    <v-combobox
                      :items="deepScanFilters.extensions.all"
                      :disabled="!deepScanFilters.extensions.enabled"
                      v-model="selectedExtensions"
                      :search-input.sync="searchInput"
                      class="select-list select-field"
                      :placeholder="deepScanFilters.extensions.enabled ? 'Type extensions separated by comma' : 'All extensions'"
                      @change="onExtChange"
                      attach
                      chips
                      deletable-chips
                      hide-selected
                      :multiple="true"
                      hide-details
                      :menu-props="{ offsetY: true }"
                      :delimiters="[',']"
                    >
                      <template slot="item" slot-scope="data">
                        <div class="select-list--inner-item">
                          <div style="width: 100%">
                            <div class="item-name">
                              {{ data.item ? data.item : '[No extension]' }}
                            </div>
                            <div v-if="data.item.count" class="item-stats d-flex">
                              <span class="file-count">
                                {{ data.item.count + ' Files' }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-slot:selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          @click:close="deepScanFilters.extensions.selected.splice(data.index, 1)"
                          close
                        >
                          {{ data.item ? data.item : '[No extension]' }}
                        </v-chip>
                      </template>
                    </v-combobox>
                    </v-col>
                  </v-row>
                  <v-row align="center" class="mt-5">
                  <v-col cols="12" md="6" sm="12" class="pl-0 py-0">
                    <v-checkbox
                        v-model="deepScanFilters.age.olderThanEnabled"
                        hide-details
                        class="shrink mr-2 my-0"
                      >
                      <template v-slot:label>
                        <p class="input-label text-style dark--text my-0">Files older than</p>
                      </template>
                    </v-checkbox>
                    <v-select
                          :items="[1,2,3,4,5,6,7,8,9,10]"
                          :item-text="item => ('Older than ' + (item + (item > 1 ? ' years' : ' year')))"
                          hide-details
                          v-model="selectedOlderThan"
                          :menu-props="{ offsetY: true }"
                          class="select-field"
                          :placeholder="deepScanFilters.age.olderThanEnabled ? 'Select a value' : 'All files'"
                          :disabled="!deepScanFilters.age.olderThanEnabled"
                        >
                        <template slot="item" slot-scope="data">
                            <div class="select-list--inner-item">
                              <div style="width: 100%">
                                <div class="item-name">
                                  {{ data.item + (data.item > 1 ? ' years' : ' year') }}
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-slot:selection="data">
                            {{ data.item + (data.item > 1 ? ' years' : ' year') }}
                          </template>
                        </v-select>
                  </v-col>
                  <!-- <v-col cols="12" md="2" sm="12" class="px-0 py-0" align-self="center">
                    <v-row v-if="deepScanFilters.age.olderThan && deepScanFilters.age.olderThanEnabled && deepScanFilters.age.newerThan && deepScanFilters.age.newerThanEnabled" align="center" justify="center">
                      <p class="input-label text-style dark--text my-0">
                        {{ deepScanFilters.age.olderThan >= deepScanFilters.age.newerThan ? 'OR' : 'AND' }}
                      </p>
                    </v-row>
                  </v-col> -->
                  <v-col cols="12" md="6" sm="12" class="pr-0 py-0">
                    <v-checkbox
                        v-model="deepScanFilters.age.newerThanEnabled"
                        hide-details
                        class="shrink mr-2 my-0"
                      >
                      <template v-slot:label>
                        <p class="input-label text-style dark--text my-0">Files newer than</p>
                      </template>
                    </v-checkbox>
                    <v-select
                          :items="[1,2,3,4,5,6,7,8,9,10]"
                          :item-text="item => ('Newer than ' + (item + (item > 1 ? ' years' : ' year')))"
                          v-model="selectedNewerThan"
                          hide-details
                          :menu-props="{ offsetY: true }"
                          class="select-field"
                          :placeholder="deepScanFilters.age.newerThanEnabled ? 'Select a value' : 'All files'"
                          :disabled="!deepScanFilters.age.newerThanEnabled"
                        >
                        <template slot="item" slot-scope="data">
                            <div class="select-list--inner-item">
                              <div style="width: 100%">
                                <div class="item-name">
                                  {{ data.item + (data.item > 1 ? ' years' : ' year') }}
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-slot:selection="data">
                            {{ data.item + (data.item > 1 ? ' years' : ' year') }}
                          </template>
                        </v-select>
                  </v-col>
                  </v-row>
                  <v-row align="center" class="mt-5">
                    <v-col cols="12" md="6" sm="12" class="pl-0 py-0">
                      <v-checkbox
                          v-model="deepScanFilters.count.enabled"
                          hide-details
                          class="shrink mr-2 my-0"
                        >
                        <template v-slot:label>
                          <p class="input-label text-style dark--text my-0">File count limit</p>
                        </template>
                      </v-checkbox>
                      <v-text-field
                        v-model="selectedFilesCount"
                        :disabled="!deepScanFilters.count.enabled"
                        :placeholder="deepScanFilters.count.enabled ? 'Enter files count' : 'All files'"
                        hide-details
                        class="select-field"
                        single-line
                        suffix="files"
                        type="number"
                      />
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pr-0 py-0">
                      <v-checkbox
                          v-model="deepScanFilters.size.enabled"
                          hide-details
                          class="shrink mr-2 my-0"
                        >
                        <template v-slot:label>
                          <p class="input-label text-style dark--text my-0">File size limit</p>
                        </template>
                      </v-checkbox>
                      <v-text-field
                        v-model="selectedFileSize"
                        :disabled="!deepScanFilters.size.enabled"
                        :placeholder="deepScanFilters.size.enabled ? 'Enter total size' : 'All files'"
                        hide-details
                        class="select-field"
                        single-line
                        suffix="MB"
                        type="number"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </div>
            </v-col>
          </v-row>
          <v-row class="mb-5">
            <v-col cols="12" md="6" sm="12">
              <p class="input-label text-style dark--text mb-3 mt-2">Start at</p>
              <input
                v-model="time"
                @focus="timeFocus = true"
                @blur="timeFocus = false"
                @change="checkTime()"
                :class="{'time-focus': timeFocus}"
                class="mt-1" type="time"
                required
              >
              <span v-if="error" class="error-time">Field is Required</span>
            </v-col>
            <v-col cols="12" md="6" sm="6" class="align-self-end">
              <v-checkbox
                v-model="runNow"
                color="primary"
                label="Run Now"
                class="mt-0"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row v-if="secondType == 's3'">
            <s3-buckets-list :error.sync="error" ref="bucketsList" />
          </v-row>
          <v-row v-if="secondType == 'onedrive'">
            <v-col>
              <p class="input-label text-style dark--text mb-0 mt-5">User ID List</p>
              <v-textarea
                v-model="usersIdList"
                rows="2"
                class="select-field user-id-list-textarea"
                hint="Enter a comma-delimited list of users id"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row v-if="type != 'my network'">
            <v-col cols="12" md="12" sm="12" class="align-self-end pt-0">
              <div class="cloud-warn-container">
                <v-checkbox
                  v-model="cloudCostAccepted"
                  color="primary"
                  class="mt-0"
                  hide-details
                />
                <div class="mt-1">
                  I understand the profiling cloud services may incur costs from that cloud service
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="cancel-btn" text @click="handleClose">Cancel</v-btn>
        <v-btn class="save-btn" type="submit" :disabled="(type !== 'my network' && !cloudCostAccepted) || !isDbConfigValid" text @click="handleConfirm">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  MY_NETWORK_TYPES,
  MY_CLOUD_SERVICES_TYPES,
  TYPES, MY_OFFICE365_TYPES,
  MY_GOOGLE_WORKSPACE_TYPES,
  MY_AWS_WORKSPACE_TYPES,
  MY_DROPBOX_TYPES,
  MY_BOX_TYPES
} from './data'
import moment from 'moment'
const showFuture = process.env.VUE_APP_SHOW_FUTURE == 'true'

export default {
  name: 'LaunchDialog',
  components: {
    'my-network-documents': () => import('./MyNetworkDocuments'),
    's3-buckets-list': () => import('./S3BucketsList'),
    'database-config': () => import('./DatabaseConfig')
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    active: {
      type: Object,
      default: null
    }
  },
  data: vm => {
    return {
      showFuture: showFuture,
      hideDeepScanFilters: true,
      deepScanFilters: {
        extensions: {
          enabled: false,
          selected: [],
          input: '',
          all: []
        },
        age: {
          olderThanEnabled: false,
          newerThanEnabled: false,
          olderThan: null,
          newerThan: null
        },
        count: {
          enabled: false,
          value: null
        },
        size: {
          enabled: false,
          value: null
        }
      },
      searchInput: null,
      valid: true,
      collector: null,
      path: '',
      timeFocus: false,
      day: '',
      time: '',
      scanCommandTypes: [
        { text: 'Discovery', value: 'discovery' },
        { text: 'Risk', value: 'deep' }
      ],
      rules: {
        required: v => !!v || 'Field is Required'
      },
      dbConfig: null,
      type: 'my network',
      secondType: 'documents',
      commandType: 'discovery',
      runNow: false,
      cloudCostAccepted: false,
      error: false,
      usersIdList: null
    }
  },
  computed: {
    ...mapGetters(['currentOrganization', 'collectors', 'loadingCollectors']),
    types () {
      return TYPES
    },
    secondTypes () {
      let arr = []
      if (this.type === 'my network') {
        arr = MY_NETWORK_TYPES
      } else if (this.type === 'my_cloud_service') {
        arr = MY_CLOUD_SERVICES_TYPES
      } else if (this.type == 'office_365') {
        arr = MY_OFFICE365_TYPES
      } else if (this.type == 'google_workspace') {
        arr = MY_GOOGLE_WORKSPACE_TYPES
      } else if (this.type == 'aws') {
        arr = MY_AWS_WORKSPACE_TYPES
      } else if (this.type == 'dropbox') {
        arr = MY_DROPBOX_TYPES
      } else if (this.type == 'box') {
        arr = MY_BOX_TYPES
      }
      return arr
    },
    isDbConfigValid () {
      if (this.secondType === 'database') {
        return this.dbConfig?.valid
      }
      return true
    },
    filteredCollectors () {
      const arr = []
      this.collectors.map((val) => {
        if (this.type == 'my network' && this.secondType == 'documents' && val.collector_type == 'on-prem') {
          arr.push(val)
        } else if (this.type == 'my network' && this.secondType == 'database' && (val.collector_type == 'docker' || val.collector_type == 'on-prem')) {
          arr.push(val)
        } else if (this.type == 'office_365' && val.configure_security && val.configure_security.azure) {
          arr.push(val)
        } else if (this.type == 'google_workspace' && val.configure_security && val.configure_security.google) {
          arr.push(val)
        } else if (val.configure_security && val.configure_security[this.type]) {
          arr.push(val)
        }
      })
      return arr
    },
    selectedExtensions: {
      get () {
        if (this.deepScanFilters?.extensions?.enabled) {
          return this.deepScanFilters.extensions.selected
        }
        return []
      },
      set (val) {
        this.deepScanFilters.extensions.selected = val
      }
    },
    selectedNewerThan: {
      get () {
        if (this.deepScanFilters?.age?.newerThanEnabled) {
          return this.deepScanFilters.age.newerThan
        }
      },
      set (val) {
        this.deepScanFilters.age.newerThan = val
      }
    },
    selectedOlderThan: {
      get () {
        if (this.deepScanFilters?.age?.olderThanEnabled) {
          return this.deepScanFilters.age.olderThan
        }
      },
      set (val) {
        this.deepScanFilters.age.olderThan = val
      }
    },
    selectedFilesCount: {
      get () {
        if (this.deepScanFilters?.count?.enabled) {
          return this.deepScanFilters.count.value
        }
      },
      set (val) {
        this.deepScanFilters.count.value = val
      }
    },
    selectedFileSize: {
      get () {
        if (this.deepScanFilters?.size?.enabled) {
          return this.deepScanFilters.size.value
        }
      },
      set (val) {
        this.deepScanFilters.size.value = val
      }
    }
  },
  watch: {
    secondTypes () {
      if (this.secondTypes && this.secondTypes.length) {
        if (!this.active || (this.type != this.active.type_of_scan) || !this.active.scan_area) {
          this.secondType = this.secondTypes[0].value
        } else if (this.active.scan_area) {
          this.secondType = this.active.scan_area
        }
      } else {
        this.secondType = null
      }
    },
    collector () {
      if (this.secondType === 's3' && !this.buckets?.length && this.collector) {
        this.$store.dispatch('loadBuckets', { collectorId: this.collector.entity_id })
      }
    },
    filteredCollectors () {
      if (this.filteredCollectors && this.filteredCollectors.length) {
        if (!this.collector) {
          this.collector = this.filteredCollectors.filter(c => c.status == 'Active')[0]
          if (!this.collector) {
            this.collector = this.filteredCollectors[0]
          }
        } else {
          if (this.filteredCollectors.findIndex(e => e.entity_id == this.collector.entity_id) < 0) {
            this.collector = this.filteredCollectors[0]
          }
        }
      } else {
        this.collector = null
      }
    }
  },
  methods: {
    checkTime () {
      if (!this.time) {
        if (!this.runNow) this.error = true
        else this.time = null
      } else this.error = false
    },
    buildDeepScanFilters () {
      const filters = {}
      const age_filters = {}
      if (this.deepScanFilters?.extensions?.enabled && this.deepScanFilters?.extensions?.selected) {
        filters.extensions = this.deepScanFilters.extensions.selected
      }
      if (this.deepScanFilters?.age?.newerThanEnabled && this.deepScanFilters?.age?.newerThan) {
        age_filters.newer_than = this.deepScanFilters.age.newerThan
      }
      if (this.deepScanFilters?.age?.olderThanEnabled && this.deepScanFilters?.age?.olderThan) {
        age_filters.older_than = this.deepScanFilters.age.olderThan
      }
      if (age_filters) {
        filters.age = age_filters
      }
      if (this.deepScanFilters?.count?.enabled && this.deepScanFilters?.count?.value) {
        filters.count = this.deepScanFilters.count.value
      }
      if (this.deepScanFilters?.size?.enabled && this.deepScanFilters?.size?.value) {
        filters.size = this.deepScanFilters.size.value
      }
      return filters
    },
    handleConfirm () {
      this.$refs.form.validate()
      this.checkTime()
      if (!this.valid) return
      var utcStart = this.time ? new moment(this.time, 'HH:mm').utc() : null

      const data = {
        entity_id: this?.active?.entity_id,
        type_of_scan: this.type,
        scan_area: this.secondType,
        collector_id: this.collector.entity_id,
        organization_id: this.currentOrganization.entity_id,
        scan_time: utcStart ? utcStart.format('hh:mm A') : null,
        drives: this.collector.drives ? this.collector.drives.join(',') : '',
        run_now: this.runNow,
        scan_command_type: this.commandType,
        collector_name: this.collector.name,
        cloud_cost_accepted: this.cloudCostAccepted
      }

      if (this.commandType === 'deep') {
        data.filters = this.buildDeepScanFilters()
      }

      if (this.secondType == 'onedrive') {
        data.usersIdList = this.usersIdList?.replace(new RegExp(',', 'g'), '|')
      } else if (this.secondType == 'database') {
        data.dbConfig = { provider: this.dbConfig.provider, connectionString: this.dbConfig.connectionString }
      } else if (this.secondType == 's3') {
        if (this.$refs.bucketsList.allBuckets) {
          data.bucket = 'all'
        } else {
          data.bucket = this.$refs.bucketsList.selectedBuckets[0]
        }
      }

      if (!this.error) {
        this.$store.dispatch('schedulingServices/addScan', data)
        this.handleClose()
      }
    },
    handleClose () {
      this.$emit('onClose')
      this.$refs.form.reset()
      this.$nextTick(() => {
        this.type = 'my network'
        this.secondType = 'documents'
      })
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    onExtChange () {
      this.searchInput = ''
    },
    updateDbConfig (data) {
      this.dbConfig = { ...this.dbConfig, ...data }
    }
  },
  mounted () {
    if (this.active) {
      this.collector = this.filteredCollectors.filter(c => c.entity_id == this.active.collector_id)[0]
      this.type = this.active?.type_of_scan
      this.secondType = this.active?.scan_area
      this.path = this.active?.drives
      this.runNow = false
      this.commandType = this.active?.scan_command_type || 'discovery'
      this.dbConfig = this.active?.dbConfig
      this.time = this.active.scan_time ? moment(this.active.scan_time, 'hh:mm A').format('HH:mm') : ''
      let usersIdList = this.active.usersIdList
      this.cloudCostAccepted = !!this.active.cloud_cost_accepted
      if (this.active.usersIdList) {
        usersIdList = usersIdList.split('|')
        usersIdList = usersIdList.join(',')
      }
      this.usersIdList = usersIdList
    } else {
      this.collector = this.filteredCollectors[0]
    }
  }
}
</script>
<style scoped>
  .cloud-warn-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    color: black;
  }
</style>

<style lang="scss">
  .v-input--checkbox {
    .v-icon {
      color: #999;
      transition: 0.3s;
    }
    .v-label {
      color: #000;
    }
  }
  input[type="time"] {
    width: 100%;
    font-family: "gt_america_extended";
    padding-inline-start: 1px;
    font-size: 16px;
    outline: none;
    padding-bottom: 5px;
    border-bottom: 1px solid black;
  }
  .time-focus {
    border-bottom: 2px solid $secondary-color !important;
  }
  .error-time {
    color: red;
    font-size: 11px;
  }
  .user-id-list-textarea {
    textarea, .theme--light.v-messages {
      color: rgba(0, 0, 0, 0.87) !important;
    }
  }
  .deep-scan-filters-header  {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

::v-deep {
  .select-list {
    .v-list-item {
      padding: 0px 5px;
    }
    .v-list-item__title {
      padding-left: 10px;
    }
    .primary--text {
      color: $black-color !important;
    }

    .v-input__slot {
      background: none !important;
      box-shadow: none !important;
    }

    .v-label--active {
      transform: translateY(-20px) scale(1) !important;
    }
    label {
      top: 0;
    }
    .v-select__selections {
      padding-left: 10px;
      font-size: 14px;
      color: $black-color !important;
      min-height: 41px !important;
    }
    .select-all {
      color: $primary-color;
      margin-left: 20px;
      font-weight: bold;
      font-size: 16px;
      cursor: pointer;
      margin-top: 15px;
    }
    .v-list-item--link {
      min-height: 0 !important;
      padding: 0 !important;
    }
    color: $card-text-color;
    &--item {
      display: flex;
      align-items: center;
      height: 48px;
      font-size: 14px;
      width: 100%;
      padding: 0 5px;
      justify-content: space-between;
      color: $card-text-color;
      width: 100%;
      &.disable {
        display: none;
        cursor: not-allowed;
        background: #eee !important;
      }
    }
    &--inner-item {
      display: flex;
      align-items: center;
      height: 48px;
      font-size: 14px;
      width: 100%;
      padding: 0 5px;
      color: $primary-color;
      .item-stats {
        color: $card-text-color;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .item-name {
          font-weight: bold;
          font-size: 16px;
        }
        .file-count {
          font-size: 14px;
          color: grey;
        }
      }
      &.disable {
        display: none;
        cursor: not-allowed;
        background: #eee !important;
      }
    }
    .v-list-item--active {
      background: #eee !important;
      .item-name {
        color: $primary-color;
      }
    }
  }
}

.v-select__selection,
.v-select__selection--comma,
.v-select.v-text-field input {
  color: black !important;
}

@media only screen and (max-width: 1370px) {
  .item-name {
    font-weight: bold;
    font-size: 14px;
  }
  .file-count {
    font-size: 11px;
  }
}
</style>
